import _ from 'lodash';
import { createContext, useContext } from 'react';
import { Subject } from 'rxjs';
export var CustomActionsPosition;
(function (CustomActionsPosition) {
    CustomActionsPosition["PRIMARY"] = "PRIMARY";
    CustomActionsPosition["MENU"] = "MENU";
    CustomActionsPosition["CONTEXTMENU"] = "CONTEXTMENU";
})(CustomActionsPosition || (CustomActionsPosition = {}));
export var CustomActionTarget;
(function (CustomActionTarget) {
    CustomActionTarget["LIVEBOARD"] = "LIVEBOARD";
    CustomActionTarget["VIZ"] = "VIZ";
    CustomActionTarget["ANSWER"] = "ANSWER";
    CustomActionTarget["SPOTTER"] = "SPOTTER";
})(CustomActionTarget || (CustomActionTarget = {}));
export const defaultEmbedContextOptions = {
    isEmbedded: false,
    isPoweredFooterHidden: false,
    useEmbedEventSubscription: _.noop,
    dispatchEmbedEvent: () => Promise.resolve(),
    embedParams: {},
    updateEmbedParams: _.noop,
    runtimeFilterParams: [],
    updateRuntimeFilterParams: _.noop,
    embedParameterParams: [],
    updateEmbedParameterParams: _.noop,
    setParameterOverridesSubject: new Subject(),
    onLayoutChange: _.noop,
    hiddenHomeLeftNavItems: [],
    hiddenHomepageModules: [],
    reorderedHomepageModules: [],
    codeBasedCustomActions: [],
};
export const EmbedContext = createContext(defaultEmbedContextOptions);
export const useEmbedContext = () => useContext(EmbedContext);
//# sourceMappingURL=embed-context.js.map